export const sizes = {
    // Limit page width. Background colors etc.
    pageMaxWidth: 1920,
    basketIconSize: '14px',
    leftContent: 768,
    content: 'min(88vw, 1690px)',
    banner: '48px',
    cornerRadius: '4px',
    cornerRadiusLarge: '6px',
    summaryBasket: '443px',
};
